import { Link } from "react-router-dom";
import { SERVICES } from "@/lib/content";
import { ArrowRight } from "lucide-react";

export default function ServicesPage() {
  return (
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-20">
      <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">
        Service catalog
      </div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter font-semibold mt-3 max-w-3xl">
        Every service, documented like it will be audited.
      </h1>
      <p className="mt-6 text-slate-600 max-w-2xl leading-relaxed">
        Below is the full catalog. Every job type below can be issued as a
        one-off work order or bundled into a portfolio-scale SLA.
      </p>

      <div className="mt-14 divide-y divide-slate-200 border-y border-slate-200">
        {SERVICES.map((s, idx) => (
          <div
            key={s.key}
            data-testid={`service-${s.key}`}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 py-10"
          >
            <div className="md:col-span-1 font-mono-alt text-xs text-slate-400 tabular-nums">
              {String(idx + 1).padStart(2, "0")}
            </div>
            <div className="md:col-span-4">
              <h2
                className="font-display text-2xl md:text-3xl tracking-tight font-medium"
                dangerouslySetInnerHTML={{ __html: s.title }}
              />
            </div>
            <div className="md:col-span-5 text-slate-600 text-sm leading-relaxed">
              <p>{s.short}</p>
              <p className="mt-3 text-slate-500">{s.long}</p>
            </div>
            <div className="md:col-span-2 flex md:justify-end items-start">
              <Link
                to="/quote"
                data-testid={`service-quote-${s.key}`}
                className="inline-flex items-center gap-2 text-sm font-semibold text-[#1E40AF] hover:text-[#1E3A8A]"
              >
                Quote this <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
